import { IParamsPagination } from "shared/TableCustom/types"
import { api as apiService, ApiService } from "./api"
import { IPaginationResponse } from "interfaces/IPagination"

class BalanceService {
  constructor(private readonly api: ApiService) {}

  public getBalanceNeedReplenishment = async (
    params: IParamsPagination,
  ): Promise<IPaginationResponse<object>> => {
    const url = `${toranjaURL}/balance/`
    return await this.api.get(url, { params: { ...params, requiresReplenishment: true } })
  }

  public getAllBalancesToday = async (
    params: IParamsPagination,
  ): Promise<IPaginationResponse<object>> => {
    const url = `${toranjaURL}/balance/`
    return await this.api.get(url, {
      params,
    })
  }
}
const toranjaURL = process.env.REACT_APP_TORANJA_API
export const balanceService = new BalanceService(apiService)
